import useLocalStorage from "./useLocalStorage";
import axios from "axios";
import useAuthentication from "./useAuthentication";
import useToastWrapper from "./useToastWrapper";
import { useTranslation } from "react-i18next";

const useAxios = () => {
  const storage = useLocalStorage();
  const auth = useAuthentication();
  const toast = useToastWrapper();
  const { t } = useTranslation();

  const dateTransformer = (data) => {
    if (data instanceof Date) {
      let d = new Date(data);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      let year = d.getFullYear();

      if (month.length < 2) {
        month = "0" + month;
      }

      if (day.length < 2) {
        day = "0" + day;
      }

      return [year, month, day].join("-");
    }

    if (Array.isArray(data)) {
      return data.map((val) => dateTransformer(val));
    }

    if (typeof data === "object" && data !== null) {
      return Object.fromEntries(
        Object.entries(data).map(([key, val]) => [key, dateTransformer(val)]),
      );
    }

    return data;
  };

  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
    transformRequest: [dateTransformer].concat(axios.defaults.transformRequest),
  });

  instance.interceptors.request.use(
    (config) => {
      const accessToken = storage.getAccessToken();
      config.headers["Authorization"] = `Bearer ${accessToken}`;

      return config;
    },
    (error) => {
      if (error.response.status === 401) {
        auth.logout();
      }
    },
  );

  instance.interceptors.request.use((config) => {
    // TODO: por defecto lenguaje INGLES. En el futuro tenemos que cogerlo de un contexto donde el usuario selecciona su idioma
    config.headers["Accept-Language"] = "en";
    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        if (error.response.status === 500) {
          toast.error(error.response.data.message);
        }
        if (error.response.status === 400) {
          console.error(error.response.data);
          const message = error.response.data.errors
            .map((err) => t(err))
            .join("<br />");
          toast.error(message);
        }
      } else {
        toast.error("No se ha podido conectar con el servidor");
      }
    },
  );

  return instance;
};

export default useAxios;
